import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-curtain-l-shaped',
  templateUrl: './curtain-l-shaped.component.html',
  styleUrls: ['./curtain-l-shaped.component.scss']
})
export class CurtainLShapedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
